import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { EmailGatewayEntity, RegexHelper } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    title: string;
    error?: boolean;
    address_list: EmailGatewayEntity[];
    handleDelete: Function;
}

function AddressPanelComponent(props: AllProps) {
    const { title, error, address_list, handleDelete } = props;

    return <div className="csv-upload-table p-0 mb-4">
        <header className="py-2">
            <h5 className="m-0">{`${address_list.length} ${title}`}</h5>
        </header>
        {address_list.map((entity: EmailGatewayEntity, index: number) => {
            return (
                <Row key={index}>
                    <Col>
                        <Icon className={`${error ? "ficon-x-circle" : RegexHelper.testEmailAddress(entity.email_address) ? "ficon-user" : "ficon-globe"} me-1 text-muted`} />
                        <span className={error ? "invalid" : ""}>{entity.email_address}</span>
                    </Col>
                    {!!entity.display_name && entity.display_name !== entity.email_address && <Col sm={3}>
                        {entity.display_name}
                    </Col>}
                    <Col xs="auto" className="ms-auto" onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}>
                        <Button
                            className="ms-auto"
                            variant="icon"
                            size="sm"
                            onClick={() => handleDelete(entity.email_address)}
                            aria-label="Delete Address or Domain" >
                            <Icon className="ficon-x" />
                        </Button>
                    </Col>
                </Row>
            );
        })}
    </div>;
};

export default React.memo(AddressPanelComponent);
